angular.module('webremote.dashboard').controller('widget_placeholderEditor',
  function ($scope, $uibModal, $location, objectManagerService, toastr) {
    $scope.om = objectManagerService
    // init values
    $scope.isDropdownOpen = false
    $scope.placeholderTitle = 'Placeholder Value'
    $scope.placeholderTitleEdit = $scope.placeholderTitle
    $scope.placeholderRegex = ''
    $scope.placeholderRegexEdit = $scope.placeholderTitle
    $scope.placeholderName = 'UnnamedPlaceholder'
    $scope.placeholderNameEdit = $scope.placeholderName
    $scope.placeholderValue = 'unset'

    $scope.$watch('activeDashboard', function () {
      $scope.om.object($scope.activeDashboard, 'dashboard').then((v) => {
        $scope.dashboard = v
      })
    })

    $scope.om.object($scope.activeDashboard, 'dashboard').then((dashboard) => {
      $scope.dashboard = dashboard

      // Watch until widgetIndex is set
      $scope.$watch('widgetIndex', async () => {
        $scope.loadStoredOptions($scope.widgetIndex)
      })
    })

    $scope.$watch('isDropdownOpen', function (newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        $scope.placeholderTitleEdit = $scope.placeholderTitle
        $scope.placeholderRegexEdit = $scope.placeholderRegex
        $scope.placeholderNameEdit = $scope.placeholderName
      }
    })

    $scope.apply = function () {
      const replacements = []
      for (const [widgetIndex, widget] of $scope.dashboard.getWidgets().entries()) {
        if (widget.id === 36) { // 36: Placeholder Editor
          const storedOptions = $scope.dashboard.getInformationForWidget(widgetIndex)
          replacements.push({ placeholder: `@${storedOptions.placeholderName}@`, value: storedOptions.placeholderValue })
        }
      }

      // patch objects
      const objectClasses = ['stream', 'streamGroup']
      for (const objectClass of objectClasses) {
        $scope.om.collection(objectClass).then((objs) => {
          for (const obj of objs.values()) {
            const patchOps = []
            for (const attribute of obj.member.attributes.values()) {
              if (attribute.key.startsWith('replace:/') && replacements.some(rep => attribute.value.includes(rep.placeholder))) {
                const path = attribute.key.split('replace:')[1]
                let value = attribute.value
                replacements.forEach(({ placeholder, value: replacement }) => {
                  value = value.replaceAll(placeholder, replacement)
                })
                patchOps.push({ op: 'replace', path, value })
              }
            }
            if (patchOps.length > 0) {
              obj.patch(patchOps)
            }
          }
        })
      }
    }

    $scope.save = function () {
      const placeholderValue = $scope.placeholderValue
      const placeholderRegex = $scope.placeholderRegex

      if (placeholderRegex) {
        const regex = new RegExp(placeholderRegex)
        if (!regex.test(placeholderValue)) {
          toastr.error('Placeholder value does not match the allowed pattern', 'Error saving placeholder', {
            closeButton: true, progressBar: true, positionClass: 'toast-bottom-right'
          })
          return
        }
      }
      $scope.saveStoredOptions()
    }

    $scope.reset = function () {
      if ($scope.widgetIndex !== undefined) {
        $scope.loadStoredOptions($scope.widgetIndex)
      }
    }

    $scope.saveConfig = function () {
      $scope.isDropdownOpen = false
      $scope.placeholderTitle = $scope.placeholderTitleEdit || 'Placeholder Value'
      $scope.placeholderRegex = $scope.placeholderRegexEdit
      $scope.placeholderName = $scope.placeholderNameEdit || 'UnnamedPlaceholder'
      $scope.saveStoredOptions()
    }

    $scope.loadStoredOptions = function (widgetIndex) {
      $scope.storedOptions = $scope.dashboard.getInformationForWidget(widgetIndex)
      if ($scope.storedOptions.placeholderTitle === undefined) {
        $scope.storedOptions.placeholderTitle = 'Placeholder Value'
      }

      if ($scope.storedOptions.placeholderRegex === undefined) {
        $scope.storedOptions.placeholderRegex = ''
      }

      if ($scope.storedOptions.placeholderName === undefined) {
        $scope.storedOptions.placeholderName = 'UnnamedPlaceholder'
      }

      // Default: Set quickActions to empty array
      if ($scope.storedOptions.placeholderValue === undefined) {
        $scope.storedOptions.placeholderValue = 'unset'
      }

      $scope.placeholderTitle = $scope.storedOptions.placeholderTitle
      $scope.placeholderTitleEdit = $scope.placeholderTitle
      $scope.placeholderRegex = $scope.storedOptions.placeholderRegex
      $scope.placeholderRegexEdit = $scope.placeholderRegex
      $scope.placeholderName = $scope.storedOptions.placeholderName
      $scope.placeholderNameEdit = $scope.placeholderName
      $scope.placeholderValue = $scope.storedOptions.placeholderValue
    }

    $scope.saveStoredOptions = function () {
      if ($scope.storedOptions !== undefined) {
        $scope.storedOptions.placeholderTitle = $scope.placeholderTitle
        $scope.storedOptions.placeholderRegex = $scope.placeholderRegex
        $scope.storedOptions.placeholderName = $scope.placeholderName
        $scope.storedOptions.placeholderValue = $scope.placeholderValue

        $scope.dashboard.storeInformationForWidget($scope.widgetIndex, JSON.stringify($scope.storedOptions))
      }
    }
  })
